import styled, { css, keyframes } from 'styled-components';

export const ProgressSliderContainer = styled.svg`
  width: 100%;
  height: 100%;
`;
ProgressSliderContainer.displayName = 'ProgressSliderContainer';

const progressSliderAnimation = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

interface ProgressSliderProps {
  timerDurationInMs: number;
  isPlaying: boolean;
  delayInMilliseconds: number;
  circlePerimeter: number;
}

export const ProgressSlider = styled.circle<ProgressSliderProps>`
  ${({ timerDurationInMs, isPlaying, delayInMilliseconds, circlePerimeter }) => css`
    stroke-dasharray: ${circlePerimeter};
    stroke-dashoffset: ${circlePerimeter};
    animation: ${progressSliderAnimation} ${timerDurationInMs}ms linear ${delayInMilliseconds}ms
      forwards;
    animation-play-state: ${isPlaying ? 'running' : 'paused'};
  `}
`;
ProgressSlider.displayName = 'ProgressSlider';
